export const APPLICATION_IN_PROGRESS_KEY = "INP";
export const APPLICATION_COMPLETE_KEY = "CMP";
export const CASE_COMPLETE_KEY = "CASE_COMPLETE";

export const APPLICATION_ERROR_CODES = {
  PRODUCT_PRICING_EXPIRED: "PRODUCT_PRICING_EXPIRED",
} as const;
